<template>
    <div class="relative flex flex-col">
        <div v-if="breadcrumbs.length" class="container relative z-50">
            <Breadcrumbs
                :breadcrumbs="breadcrumbs"
                class="absolute left-4 top-4"
            />
        </div>
        <slot />
        <template v-for="(blok, index) in blocks" :key="blok._uid">
            <PageBuildingLazyBlock
                :blok="blok"
                :next-block="blocks[index + 1]"
                :root-margin="index === 0 ? '0px' : '400px 0px'"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import type { BreadcrumbType } from '#shared/types/BreadcrumbType';
import Breadcrumbs from '~/components/Breadcrumbs.vue';
import { urlFromStoryblokLinkField } from '~/utils/helpers';
import { flattenPromoContentSwitchers } from '~/utils/promoContentSwitcher';

const props = defineProps<{
    story: any;
}>();

const blocks = computed(() =>
    flattenPromoContentSwitchers(props.story.content.blocks ?? []),
);

const breadcrumbs = computed<BreadcrumbType[]>(() => {
    if (!props.story.content.breadcrumbs) {
        return [];
    }
    return props.story.content.breadcrumbs.map((breadcrumb: any) => {
        return {
            label: breadcrumb.label,
            path: urlFromStoryblokLinkField(breadcrumb.link),
        } as BreadcrumbType;
    });
});
</script>
